export enum SkinItemType {
    color = 'color',
    text = 'text',
    boolean = 'boolean',
    textarea = 'textarea',
    file = 'file'
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/skinItemType.enum.ts